import { notification } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/components/Form/TextField';
import { ValidationRules } from 'src/components/Form/ValidationRules';
import { Modal } from 'src/components/Modal/Modal';
import { LoanApplicationsStore } from 'src/stores/LoanApplicationsStore/LoanApplicationsStore';
import { ConstraintViolationError } from 'src/utils/ErrorDataHelper';
import { FormHelper } from 'src/utils/FormHelper';
import { addModalRenderer, ModalRendererProps } from 'src/utils/ModalRenderer';

type DeclineApplicationDialogProps = ModalRendererProps<{
    applicationId: string | number;
}>;

const DeclineApplicationDialogFn = observer(
    ({ applicationId, onSuccess, ...props }: DeclineApplicationDialogProps) => {
        const { t } = useTranslation();

        useEffect(() => {
            return () => {
                store.declineLoader.reset();
            };
        }, []);

        const fields = FormHelper.getFieldDataItems(
            store.declineLoader.errorData as ConstraintViolationError,
        );

        const onFinish = async (values: DeclineApplicationFormValues) => {
            await store.decline(String(applicationId), values.reason);
            if (!store.declineLoader.hasError) {
                notification.success({
                    message: t('App.DeclineApplicationDialog.DeclineSuccess'),
                });
                onSuccess?.();
            } else {
                return Promise.reject();
            }
        };

        return (
            <Modal
                title={t('App.DeclineApplicationDialog.Title')}
                okText={t('App.DeclineApplicationDialog.Confirm')}
                isLoading={store.declineLoader.isLoading}
                formProps={{ fields }}
                onFinish={onFinish}
                {...props}
            >
                <TextField
                    name={formNames.getPath('reason')}
                    label={t('App.DeclineApplicationDialog.Reason')}
                    rules={[ValidationRules.required]}
                />
            </Modal>
        );
    },
);

type DeclineApplicationFormValues = {
    reason: string;
};

const formNames = FormHelper.createNameProvider<DeclineApplicationFormValues>();
const store = LoanApplicationsStore;

export const DeclineApplicationDialog = addModalRenderer(
    DeclineApplicationDialogFn,
);
